import { mountRouteUrl, ROUTES } from '@routes'

export const SESSION_STORAGE_KEY_ENABLED_ONLY = 'marketing.coupons.enabledOnly'
export const SESSION_STORAGE_KEY_INCLUDE_DYNAMIC = 'marketing.coupons.includeDynamic'
export const SESSION_STORAGE_KEY_VALID_ONLY = 'marketing.coupons.validOnly'

export const getDefaultCouponsRoute = () => {
  return mountRouteUrl(ROUTES.coupons.path, undefined, {
    enabledOnly: sessionStorage.getItem(SESSION_STORAGE_KEY_ENABLED_ONLY) ?? 'true',
    includeDynamic: sessionStorage.getItem(SESSION_STORAGE_KEY_INCLUDE_DYNAMIC) ?? 'true',
    validOnly: sessionStorage.getItem(SESSION_STORAGE_KEY_VALID_ONLY) ?? 'true',
  })
}
